/* global dicoKeys */
/* global google */
/* global addMarker */
/* global openMarker */
/* global btnLoader */

/* Check Stock in Store JS */

import {
  isEmpty,
} from '../Utils';
import GlobalVars from '../GlobalVars';
import AjaxURL from '../AjaxURL';
import * as Map from '../widgets/Map';

let geocoder = {};
let isInitialized = false;

const currentCountry = (typeof GlobalVars !== 'undefined') ? GlobalVars.Country : '';
const currentLocation = { lat: null, lng: null };
let stores = [];
let storesIdList = [];
let storesCoordsList = [];
let cityQuery = '';
const imgpath = '/img/occ2016/style-guide/store-locator/locator-store2-full-icon-76.png';
const storeIcon = {
  url: imgpath,
};
const $locationInput = $('#locationInput');
const $validateCityBtn = $('#validateCityBtn');
const $storesList = $('#checkStockList');
const $jsMessageDom = $('.o-checkstock__list .js-message');
let storeCategoryIcon = 'locator_store"';
const $spinner = $('.o-checkstock__list .js-storesList-spinner');
const $checkstockPopin = $('#checkstockPopin');
/**
 * Add store to map and list
 */
function addStore(store, i) {
  storesIdList.push(store.storeID);
  storesCoordsList.push(`${store.coord.latitude},${store.coord.longitude}`);

  // Change store icon
  switch (store.Category) {
    case 'MALL_STORE':
      storeCategoryIcon = 'locator_store"';
      break;
    default:
      storeCategoryIcon = 'locator_store2"';
  }

  // Add store to stores list
  $storesList.append(`<li>
    <div id="store${store.storeID}" class="m-store-checkstock">
      <div class="m-store-checkstock__store-image">
        <i class="m-store-checkstock__store-icon a-icon a-icon--${storeCategoryIcon}" aria-hidden="true"></i>
        <p id class="m-store-checkstock__store-distance"></p>
      </div>
      <div class="m-store-checkstock__stock">
        <address>
          <span class="m-store-checkstock__data m-store-checkstock__store-name a-text a-text--bold">${store.Name}</span>
          <span class="m-store-checkstock__data m-store-checkstock__store-address a-text">${store.Address1}<br>${store.ZipCode} ${store.City}</span>
          <span class="m-store-checkstock__store-hours m-icon-text m-icon-text--top-icon">
            <i class="m-icon-text__icon a-icon a-icon--time" aria-hidden="true"></i>
            <span class="m-store-checkstock__data a-text">${store.OpeningHours1}</span></span>
            <span class="m-store-checkstock__data m-store-checkstock__store-phone m-icon-text">
              <i class="m-icon-text__icon a-icon a-icon--phone" aria-hidden="true"></i>
              <span class="a-text a-numbers">${store.Phone}</span>
            </span>
            <span class="m-store-checkstock__store-stock">${dicoKeys.Loading}...</span>
          </address>
      </div>
      <button type="button" data-index="${i}" id="btnOpen${i}" class="m-store-checkstock__btn a-btn a-btn--secondary-1">${dicoKeys.StoreSeeOnMap}</button>
      <div class="m-store-checkstock__store-link">
        <a href="${store.URL}" class="m-store-checkstock__data m-store-checkstock__chevron" aria-label="${dicoKeys.ReadMore}">></a>
      </div>
    </div>
  </li>`);
  // Create google map infowindow
  const contentString = `<div class="m-store-infowindow">
    <img class="m-store-infowindow__image a-img" src="https://img.loccitane.com/OCMS/img/lib/store/small/${store.storeID}.jpg?nodef=true" alt="${store.Name}" title="${store.Name}" />
    <div class="m-store-infowindow__data">
      <address>
        <span class="m-store-infowindow__info m-store-infowindow__store-name a-text a-text--bold">${store.Name}</span>
        <span class="m-store-infowindow__info m-store-infowindow__store-address">${store.Address1}</span>
        <span class="m-store-infowindow__info m-store-infowindow__store-city">${store.ZipCode} ${store.City}</span>
        <span class="m-store-infowindow__info m-store-infowindow__store-phone"><span class="a-numbers">${store.Phone}</span></span>
        <span class="m-store-infowindow__info m-store-infowindow__store-hours">${store.OpeningHours1}</span>
        <a href="${store.URL}" class="m-store-infowindow__info a-link">${dicoKeys.ReadMore}</a>
      </address>
    </div>
  </div>`;

  if (!GlobalVars.IsMobile && typeof google !== 'undefined') {
    const infowindow = new google.maps.InfoWindow({
      content: contentString
    });
    // Add google map marker
    const storePos = new google.maps.LatLng(store.coord.latitude, store.coord.longitude);

    Map.addStoreMarker(storePos, '', storeIcon, infowindow);
    // Add event on marker click
    $storesList.on('click', `#btnOpen${i}`, (event) => {
      Map.openMarker($(event.target).data('index'));
    });
  }
}

/**
 * clear the map from markers
 */
function emptyMap() {
  storesIdList = [];
  storesCoordsList = [];
  if (typeof Map !== 'undefined') {
    Map.clearMarkers();
  }
}

/**
 * Get store distance from current location
 */
function getDistancePerStore() {
  // Calculate distance
  $.getJSON(
    AjaxURL.googleDistanceApi,
    {
      origins: `${currentLocation.lat}, ${currentLocation.lng}`,
      destinations: storesCoordsList.join('|'),
      key: window.GGL_API_KEY,
      units: 'metric',
    }
  )
    .done((data) => {
      const distancesArray = data.rows[0].elements;
      $('#checkStockList .m-store-checkstock .m-store-checkstock__store-distance').each((i, element) => {
        $(element).html(distancesArray[i].distance.text);
      });
      $jsMessageDom.text('');

      return true;
    })
    .fail((error) => {
      //  Request error
      console.error(error);
    });
}

/**
 * Get Stock per Store
 */
function getStockPerStore(storesIdArray) {
  $.getJSON(
    AjaxURL.getStockStoresProductPage,
    {
      c: GlobalVars.C,
      l: GlobalVars.L,
      task: 'getStockStores',
      skus: OCMS.productpage.sku,
      stores: storesIdArray.join(',')
    }
  )
    .done((data) => {
      let cssClass = '';
      let text = '';

      data.forEach((stock) => {
        let statusCode = '';
        if (stock.values.length === 0) {
          cssClass = 'm-store-checkstock__store-stock a-alert-stock a-alert-stock--small a-alert-stock--unavailable';
          text = dicoKeys.CheckStock_error;
        } else {
          statusCode = stock.values[0].status;
        }

        if (!isEmpty(statusCode) && !isNaN(statusCode)) {
          switch (statusCode) {
            case 0: {
              cssClass = 'm-store-checkstock__store-stock a-alert-stock a-alert-stock--small a-alert-stock--out';
              text = dicoKeys.CheckStock_nostock;

              break;
            }
            case 1: {
              // cssClass = '';
              cssClass = 'm-store-checkstock__store-stock a-alert-stock a-alert-stock--small';
              text = dicoKeys.CheckStock_instock;

              break;
            }
            case 2: {
              cssClass = 'm-store-checkstock__store-stock a-alert-stock a-alert-stock--small a-alert-stock--unavailable';
              text = dicoKeys.CheckStock_error;

              break;
            }
            default: {
              break;
            }
          }
        }

        const $storeStock = $(`#store${stock.storeID}`).find('.m-store-checkstock__store-stock');
        $storeStock.attr('class', cssClass);
        $storeStock.html(text);
      });

      return true;
    })
    .fail((error) => {
      //  Request error
      console.error(error);
    });
}

/**
 * Get Stores List by GPS position
 */
function getStoresListByPosition(latitude, longitude, getType) {
  if (!GlobalVars.IsMobile) {
    emptyMap();
  }
  let parameters = {};
  if (getType) {
    parameters = {
      c: GlobalVars.C,
      l: GlobalVars.L,
      // country: GlobalVars.Country,
      // city: '',
      lat: latitude,
      lon: longitude,
      type: 'OWNED'
      // RU Problem : NON_OWNED Stores doesn't appear on GMaps because of this filter
    };
  } else {
    parameters = {
      c: GlobalVars.C,
      l: GlobalVars.L,
      lat: latitude,
      lon: longitude
    };
  }
  $.getJSON(
    AjaxURL.storesJson, parameters
  )
  .done((data) => {
    $spinner.hide();
    stores = data.storeList.store;
    $storesList.html('');
    if (isEmpty(stores) || !stores.length) {
      // No stores available
      $jsMessageDom.text(`${dicoKeys.NoResult}`);
      return false;
    }

    stores.forEach((store, i) => {
      addStore(store, i);
      if (i === stores.length - 1) {
        getStockPerStore(storesIdList);
      }
    });
    // getDistancePerStore();
    $jsMessageDom.text('');
    return true;
  })
  .fail((error) => {
    //  Request error
    $spinner.hide();
    console.error(error);
    $jsMessageDom.text(`${dicoKeys.NoResult}`);
    return false;
  });
}

/**
 * Get Stores List by Country
 */
function getStoresListByCountry(searchCountry) {
  $.getJSON(
    AjaxURL.storesJson,
    {
      country: searchCountry,
      type: 'OWNED'
    }
  )
  .done((data) => {
    $spinner.hide();
    stores = data.storeList.store;
    $storesList.html('');
    if (isEmpty(stores) || !stores.length) {
      // No stores available
      $jsMessageDom.text(`${dicoKeys.NoResult}`);
      return false;
    }
    stores.forEach((store, i) => {
      addStore(store, i);
      if (i === stores.length - 1) {
        getStockPerStore(storesIdList);
      }
    });

    // getDistancePerStore();
    $jsMessageDom.text('');
    return true;
  })
  .fail((error) => {
    //  Request error
    $spinner.hide();
    console.error(error);
    $jsMessageDom.text(`${dicoKeys.NoResult}`);
    return false;
  });
}

/**
 * Get current location
 */
function getLocationOnMap(searchAddress) {
  /* HTTPS issue , no more geolocation
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(updateLocation);
  } else {
    // Browser doesn't support Geolocation
    defaultLocation();
    // handleLocationError(false, infoWindow, map.getCenter());
  }
  */
  let getType = true;
  if ($checkstockPopin.length && cityQuery !== '') {
    getType = false;
  }

  if (typeof google !== 'undefined') {
    geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: searchAddress, region: GlobalVars.ISO2 }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        currentLocation.lat = results[0].geometry.location.lat();
        currentLocation.lng = results[0].geometry.location.lng();
        if (!isInitialized) {
          if (!GlobalVars.IsMobile) {
            Map.init('checkStockMap', { lat: currentLocation.lat, lon: currentLocation.lng });
            Map.setZoom(6);
          }
          getStoresListByCountry(currentCountry);
          isInitialized = true;
        } else {
          if (!GlobalVars.IsMobile) {
            Map.setCenter(currentLocation.lat, currentLocation.lng);
            Map.setZoom(12);
          }
          getStoresListByPosition(currentLocation.lat, currentLocation.lng, getType);
        }
      }
    });
  }
}

/**
 * Get Stores List by city form
 */
function getStoresListByCity(query) {
  if (!GlobalVars.IsMobile) {
    emptyMap();
  }
  $.getJSON(
    AjaxURL.storesJson,
    {
      c: GlobalVars.C,
      l: GlobalVars.L,
      country: GlobalVars.Country,
      city: query,
      type: 'OWNED'
    }
  )
  .done((data) => {
    $spinner.hide();
    stores = data.storeList.store;
    $storesList.empty();
    if (isEmpty(stores) || !stores.length) {
      // No stores available
      $jsMessageDom.text(`${dicoKeys.NoResult}`);
      return false;
    }
    getLocationOnMap(query);
    stores.forEach((store, i) => {
      addStore(store, i);
      if (i === stores.length - 1) {
        getStockPerStore(storesIdList);
      }
    });

    // getDistancePerStore();
    $jsMessageDom.text('');

    return true;
  })
  .fail((error) => {
    //  Request error
    $spinner.hide();
    console.error(error);
    $jsMessageDom.text(`${dicoKeys.NoResult}`);
    return false;
  });
}

/**
 * Update map location pin
 */
function updateMapLocation(position) {
  if (typeof google !== 'undefined') {
    const pos = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
    Map.init('checkStockMap', { lat: position.coords.latitude, lon: position.coords.longitude });
    Map.addMarker(pos);
  }
}

/**
 * Handle location errors
 */
 /*
function handleLocationError(browserHasGeolocation, infoWindow, pos) {
  infoWindow.setPosition(pos);
  infoWindow.setContent(browserHasGeolocation ?
                        'Error: The Geolocation service failed.' :
                        'Error: Your browser doesn\'t support geolocation.');
}
*/

/**
 * Update current location
 */
function updateLocation(position) {
  currentLocation.lat = position.coords.latitude;
  currentLocation.lng = position.coords.longitude;
  getStoresListByPosition(position);

  if (!GlobalVars.IsMobile) {
    updateMapLocation(position);
  }
}

/**
 * Validate form function
 */
function validateForm() {
  $spinner.show();
  cityQuery = $locationInput.val();
  if (cityQuery !== '') {
    // getStoresListByCity(cityQuery);
    getLocationOnMap(cityQuery);
  } else {
    $jsMessageDom.text(`${dicoKeys.NoResult}`);
  }
}

/**
 * initialisation
 */
function init() {
  if (!isInitialized) {
    getLocationOnMap(currentCountry);
  }
  $validateCityBtn.on('click', (event) => {
    event.preventDefault();
    validateForm();
  });
  $locationInput.on('keydown', (event) => {
    if (event.which === 13) {
      event.preventDefault();
      validateForm();
    }
  });
}

export {
  init,
  currentLocation,
  getDistancePerStore,
  getStoresListByPosition,
  getStoresListByCountry,
  getStoresListByCity,
  updateLocation,
  updateMapLocation,
};



// WEBPACK FOOTER //
// ./js/common/organism/checkstock.js